<template>
    <div class="page-wrapper">
        <div class="project-header-section">
            <div class="single-project-header">
                <div>
                    <h2 class="single-project-title">Pepper Rodeo</h2>
                    <h5 class="single-project-subtitle">A grocery list and recipe manager.</h5>
                </div>
                <div class="links">
                    <a class="single-project-link" href="https://github.com/dallincoons/pepperrodeov2" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.58 31.77">
                            <title>github-icon</title>
                            <path class="cls-github" d="M16.29,0a16.29,16.29,0,0,0-5.15,31.75c.82.15,1.11-.36,1.11-.79s0-1.41,0-2.77C7.7,29.18,6.74,26,6.74,26a4.36,4.36,0,0,0-1.81-2.39c-1.47-1,.12-1,.12-1a3.43,3.43,0,0,1,2.49,1.68,3.48,3.48,0,0,0,4.74,1.36,3.46,3.46,0,0,1,1-2.18c-3.62-.41-7.42-1.81-7.42-8a6.3,6.3,0,0,1,1.67-4.37,5.94,5.94,0,0,1,.16-4.31s1.37-.44,4.48,1.67a15.41,15.41,0,0,1,8.16,0c3.11-2.11,4.47-1.67,4.47-1.67A5.91,5.91,0,0,1,25,11.07a6.3,6.3,0,0,1,1.67,4.37c0,6.26-3.81,7.63-7.44,8a3.85,3.85,0,0,1,1.11,3c0,2.18,0,3.94,0,4.47s.29.94,1.12.78A16.29,16.29,0,0,0,16.29,0Z"/>
                        </svg>
                    </a>
                    <a class="single-project-link" href="https://pepperrodeo.com/#/" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.73 31.73">
                            <title>website-icon</title>
                            <path class="cls-web-icon" d="M30.85,21.09a15.92,15.92,0,0,0,0-10.44.88.88,0,0,0-.05-.15,15.87,15.87,0,0,0-29.87,0l-.05.15a15.92,15.92,0,0,0,0,10.44l.05.14a15.87,15.87,0,0,0,29.87,0,.78.78,0,0,0,.05-.14Zm-15,8.37c-.61,0-1.58-1.09-2.4-3.54a25.24,25.24,0,0,1-.93-4H19.2a25.2,25.2,0,0,1-.94,4c-.82,2.45-1.79,3.54-2.39,3.54Zm-3.61-9.82c-.11-1.21-.17-2.48-.17-3.77s.06-2.56.17-3.78h7.21c.11,1.22.17,2.48.17,3.78s-.06,2.56-.17,3.77Zm-10-3.77a13.49,13.49,0,0,1,.54-3.78H10c-.11,1.24-.16,2.51-.16,3.78s0,2.53.16,3.77H2.81a13.42,13.42,0,0,1-.54-3.77Zm13.6-13.6c.6,0,1.57,1.1,2.39,3.54a25.47,25.47,0,0,1,.94,4H12.54a25.24,25.24,0,0,1,.93-4c.82-2.44,1.79-3.54,2.4-3.54Zm5.88,9.82h7.18a13.71,13.71,0,0,1,0,7.55H21.75c.11-1.24.16-2.51.16-3.77s-.05-2.54-.16-3.78ZM28,9.82H21.49a21.78,21.78,0,0,0-2.07-7.07A13.66,13.66,0,0,1,28,9.82ZM12.31,2.75a22,22,0,0,0-2.07,7.07H3.7a13.62,13.62,0,0,1,8.61-7.07ZM3.7,21.91h6.54A22.1,22.1,0,0,0,12.31,29,13.66,13.66,0,0,1,3.7,21.91ZM19.42,29a21.85,21.85,0,0,0,2.07-7.08H28A13.7,13.7,0,0,1,19.42,29Z"/>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="highlights-section">
                <ul class="highlights-list">
                    <li class="highlight">
                        <span class="bolt-bullet-point">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.35 82.91">
                                <title>bolt</title>
                                <path class="cls-bolt" d="M16.15,25.18,28.35,0,10.61,1.48,1.37,30.81l2.77-.26-.06.2L1.31,31h0l7-.67L1.5,54.54l1.65-.2-.06.26-1.66.2v.06l5.86-.71-5,19.76L20.1,48.31l2.16-.17L1.12,78.49,0,82.91l24.35-35-9,.75,12.3-24.57Zm8-24.81L26.26.19l-12.11,25L12,25.37ZM13.35,48.71l-2.12.17,12.2-24.37,2.13-.19Z"/>
                            </svg>
                        </span>
                        100% Test Coverage
                    </li>
                    <li class="highlight">
                        <span class="bolt-bullet-point">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.35 82.91">
                                <title>bolt</title>
                                <path class="cls-bolt" d="M16.15,25.18,28.35,0,10.61,1.48,1.37,30.81l2.77-.26-.06.2L1.31,31h0l7-.67L1.5,54.54l1.65-.2-.06.26-1.66.2v.06l5.86-.71-5,19.76L20.1,48.31l2.16-.17L1.12,78.49,0,82.91l24.35-35-9,.75,12.3-24.57Zm8-24.81L26.26.19l-12.11,25L12,25.37ZM13.35,48.71l-2.12.17,12.2-24.37,2.13-.19Z"/>
                            </svg>
                        </span>
                        Utilizes Cosmos Design Pattern
                    </li>
                    <li class="highlight">
                        <span class="bolt-bullet-point">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.35 82.91">
                                <title>bolt</title>
                                <path class="cls-bolt" d="M16.15,25.18,28.35,0,10.61,1.48,1.37,30.81l2.77-.26-.06.2L1.31,31h0l7-.67L1.5,54.54l1.65-.2-.06.26-1.66.2v.06l5.86-.71-5,19.76L20.1,48.31l2.16-.17L1.12,78.49,0,82.91l24.35-35-9,.75,12.3-24.57Zm8-24.81L26.26.19l-12.11,25L12,25.37ZM13.35,48.71l-2.12.17,12.2-24.37,2.13-.19Z"/>
                            </svg>
                        </span>
                        Laravel
                    </li>
                    <li class="highlight">
                        <span class="bolt-bullet-point">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.35 82.91">
                                <title>bolt</title>
                                <path class="cls-bolt" d="M16.15,25.18,28.35,0,10.61,1.48,1.37,30.81l2.77-.26-.06.2L1.31,31h0l7-.67L1.5,54.54l1.65-.2-.06.26-1.66.2v.06l5.86-.71-5,19.76L20.1,48.31l2.16-.17L1.12,78.49,0,82.91l24.35-35-9,.75,12.3-24.57Zm8-24.81L26.26.19l-12.11,25L12,25.37ZM13.35,48.71l-2.12.17,12.2-24.37,2.13-.19Z"/>
                            </svg>
                        </span>
                        Vue
                    </li>
                </ul>
            </div>
        </div>
        <div class="details-section">
            <p class="details">
                Bits of moving fluff rich in heavy atoms another world two ghostly white figures in coveralls and helmets are soflty dancing cosmic ocean a billion trillion. Kindling the energy hidden in matter inconspicuous motes of rock and gas great turbulent clouds with pretty stories for which there's little good evidence vastness is bearable only through love hundreds of thousands.
            </p>
        </div>

        <router-link to="/" class="back-button">&#8592 Back</router-link>

    </div>
</template>

<script>
    export default {
        name: 'PepperRodeo'
    }
</script>

<style>
    .project-header-section {
        display: grid;
        margin-top: 4rem;
    }

    .single-project-header {
        display: grid;
        grid-template-columns: 1fr auto;
    }

    .single-project-title {
        margin: 0;
        text-transform: uppercase;
        color: #10abd1;
    }

    .single-project-subtitle {
        margin: 0;
        font-style: italic;
        font-weight: 400;
        font-size: 16px;
    }

    .links {
        display: flex;
        justify-content: space-between;
        margin-top: .83rem;
        width: 80px;
        justify-self: flex-end;
    }

    .single-project-link {
        width: 30px;
        transition: all .2s ease-in-out;
    }

    .single-project-link svg {
        width: 100%;
    }

    .single-project-link:hover {
        transform: translateY(-2px);
        cursor: pointer;
        transition: all .2s ease-in-out;
    }

    .single-project-link:hover .cls-github {
        fill: #10abd1;
        transition: all .2s ease-in-out;
    }

    .single-project-link:hover .cls-web-icon {
        fill: #10abd1;
        transition: all .2s ease-in-out;
    }

    .highlights-list {
        margin-top: 2rem;
        font-weight: 500;
    }

    .highlight {
        display: flex;
    }

    .bolt-bullet-point {
        width: 10px;
        margin-right: 10px;
    }

    .bolt-bullet-point svg {
        width: 100%;
    }

    .cls-github {fill: #0d0d0d;}
    .cls-web-icon {fill: #0d0d0d;}

    .cls-bolt{fill:#01abd1;}

    .details {
        line-height: 2;
    }

    .back-button {
        color: #10abd1;
        text-decoration: none;
        font-weight: 600;
        font-size: 1.2rem;
        transition: all .2s ease-in-out;
    }

    .back-button:hover {
        font-size: 1.3rem;
        font-weight: 700;
        color: #0d0d0d;
        transition: all .2s ease-in-out;
    }


</style>
